import React, { useEffect, useState } from "react";
import Layout from "../../../Components/Layout";
import { useNavigate } from "react-router-dom";
import {
  BigText,
  btnfont,
  DarkBold,
  LighterBold,
  Lightly,
} from "../../../Assets/CSS/Text";
import { Newbtn } from "../../../Assets/CSS/Button";
import Skeleton from "react-loading-skeleton";
import { Icon } from "@iconify/react";
import axios from "axios";
import toast from "react-hot-toast";

function TeamList() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedTeamId, setSelectedTeamId] = useState(null);
  const openDeleteModal = (teamId) => {
    setSelectedTeamId(teamId);
    setShowDeleteModal(true);
  };
  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedTeamId(null);
  };

  const [teamList, setTeamsList] = useState([]);

  const token = localStorage.getItem("token");

  // Fetch employee list
  useEffect(() => {
    const featchuser = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/teams`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log(`${process.env.REACT_APP_BACKEND_URL}/teams`);
        setTeamsList(response?.data?.content);
        console.log(response?.data, "datateam");
      } catch (error) {
        console.error("Error creating team:", error);
      }
    };
    featchuser();
  }, []);

  const handleDeleteTeam = async () => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/teams/${selectedTeamId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Remove deleted team from UI
      setTeamsList((prev) =>
        prev.filter((team) => team.teamId !== selectedTeamId)
      );

      toast.success("Team deleted successfully!");

      closeDeleteModal();

    } catch (error) {
      console.error("Delete Team Error:", error);
      toast.error("Failed to delete team");
    }
  };

  const filteredTeams = teamList.filter((team) =>
    team.teamName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Layout>
      <div className="backgound-main-content p-3">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 style={BigText}>Teams</h2>
          <button
            style={{ ...btnfont, ...Newbtn }}
            onClick={() => navigate("/createTeam")}
          >
            <Icon icon="material-symbols:add-rounded" width="18" height="18" />
            New Team
          </button>
        </div>

        {/* Search Bar */}
        <div className="timesheet-controls">
          <div className="search-bar" style={{ boxShadow: "none" }}>
            <input
              type="text"
              className="form-control border-0"
              placeholder="Search team name"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Icon
              icon="iconamoon:search"
              width="20"
              height="20"
              color="rgba(0, 175, 239, 1)"
            />
          </div>
        </div>
        {/* Table */}
        <div className="timesheet-table mb-4 table-responsive">
          <table className="employee-table timesheet-table ">
            <thead>
              <tr>
                <th style={LighterBold}>Team Name</th>
                <th style={LighterBold}>Description</th>
                <th style={LighterBold}>Size</th>
                <th style={LighterBold}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading
                ? Array.from({ length: 5 }).map((_, index) => (
                  <tr key={index}>
                    <td>
                      <Skeleton width={100} />
                    </td>
                    <td>
                      <Skeleton width={100} />
                    </td>
                    <td>
                      <Skeleton width={50} />
                    </td>
                    <td className="d-flex gap-3">
                      <Skeleton width={20} height={20} circle />
                      <Skeleton width={20} height={20} circle />
                    </td>
                  </tr>
                ))
                : filteredTeams.map((team, index) => (
                  <tr key={index}>
                    <td style={DarkBold}>{team.teamName}</td>
                    <td style={Lightly}>{team.teamDescription}</td>
                    <td style={Lightly}>{team?.teamMembers?.length}</td>
                    <td className="d-flex gap-3">
                      {/* Edit */}
                      <Icon
                        icon="mdi:edit"
                        style={{
                          color: "#00AFEF",
                          fontSize: "18px",
                          cursor: "pointer",
                        }}
                        onClick={() => navigate(`/editTeam/${team.teamId}`)}

                      />
                      <Icon
                        icon="hugeicons:view"
                        style={{
                          color: "#00AFEF",
                          fontSize: "18px",
                          cursor: "pointer",
                        }}
                        onClick={() => navigate(`/teamView/${team.teamId}`)}
                      />
                      <Icon
                        icon="material-symbols:delete-outline"
                        style={{
                          color: "#DD0000",
                          fontSize: "18px",
                          cursor: "pointer",
                        }}
                        onClick={() => openDeleteModal(team.teamId)}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <>
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div
                className="modal-content border-0"
                style={{
                  borderRadius: "16px",
                  padding: "20px",
                }}
              >
                <div className="modal-body text-center">

                  {/* Delete Icon */}
                  <div
                    className="d-flex justify-content-center align-items-center mx-auto mb-3"
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      background: "#FFF1F1",
                    }}
                  >
                    <Icon
                      icon="material-symbols:delete-outline"
                      width="30"
                      height="30"
                      style={{ color: "#E53935" }}
                    />
                  </div>

                  {/* Heading */}
                  <h3
                    style={{
                      fontWeight: "700",
                      fontSize: "28px",
                      marginBottom: "10px",
                    }}
                  >
                    Confirm Delete
                  </h3>

                  {/* Text */}
                  <p
                    style={{
                      color: "#666",
                      fontSize: "16px",
                      marginBottom: "25px",
                    }}
                  >
                    Are you sure you want to delete this team?
                  </p>

                  {/* Buttons */}
                  <div className="d-flex justify-content-center gap-3">
                    <button
                      className="btn"
                      onClick={closeDeleteModal}
                      style={{
                        minWidth: "100px",
                        borderRadius: "10px",
                        padding: "10px 20px",
                        background: "#F1F1F1",
                        color: "#555",
                        fontWeight: "500",
                      }}
                    >
                      Cancel
                    </button>

                    <button
                      className="btn"
                      onClick={handleDeleteTeam}
                      style={{
                        minWidth: "100px",
                        borderRadius: "10px",
                        padding: "10px 20px",
                        background: "#E53935",
                        color: "#fff",
                        fontWeight: "600",
                      }}
                    >
                      Delete
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </Layout>
  );
}

export default TeamList;
